import PropTypes from 'prop-types';

export default PropTypes.shape({
  items: PropTypes.arrayOf(
    PropTypes.shape({
      passengerType: PropTypes.string,
      quantity: PropTypes.number.isRequired,
      difference: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired
    })
  ).isRequired,
  total: PropTypes.number.isRequired
});
